<template>
  <q-avatar
    :size="size"
    text-color="primary"
  >
    <q-icon
      v-if="!imgSrc"
      :name="icon"
      :size="size"
    />
    <img
      v-else
      alt="avatar"
      :src="imgSrc"
    />
  </q-avatar>
</template>

<script setup lang="ts">
export interface GlobalAvatarProps {
  icon?: string
  imgSrc?: string | null
  size?: string
}

withDefaults(defineProps<GlobalAvatarProps>(), {
  icon: 'profile',
  size: '5rem',
})
</script>
